import React from 'react';
import Button from '../Button/Button.react';
import {PropTypes} from 'prop-types';
import LocaleContext from '../../../../Contexts/Locale/Context';
import './TourMenuPicker.less';

class TourMenuPicker extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        onSelectGroup: PropTypes.func,
        tour: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    };

    render() {
        let props = this.props;
        let tourData = props.tour.get('tourData') || null;
        let groupId = props.tour.get('groupId');
        let groups = (tourData !== null ? tourData.groups : null) || null;
        let className = `TourMenuPicker${this.props.className ? ` ${this.props.className}` : ''}`;
        if (groups !== null && groups.length > 1) {
            return (
                <LocaleContext.Consumer>
                    {(getTranslation) => (
                        <div className={className}>
                            {groups.map((group, index) => (
                                <Button
                                    onClick={props.onSelectGroup}
                                    id={group.groupId}
                                    label={getTranslation('groupLabels', group.translationKey)}
                                    key={index}
                                    disabled={group.groupId === groupId}
                                />
                            ))}
                        </div>
                    )}
                </LocaleContext.Consumer>
            );
        }
        return null;
    }
}

export default TourMenuPicker;
